export default __webpack_public_path__ + "static/media/ic_notification_inactive.03e00e4d.svg";